// extracted by mini-css-extract-plugin
var _1 = "Node_error__41f6b";
export { _1 as "error" }
